export const RETURNS_SETTINGS_SET_PORTALS = 'RETURNS_SETTINGS_SET_PORTALS'
export const RETURNS_SETTINGS_SET_REASONS = 'RETURNS_SETTINGS_SET_REASONS'
